module.exports = __webpack_public_path__ + "static/media/diktat-17.c7331d23.mp3";